// Same-origin gold-coin economy API. Mirrors auth.js's request() shape: the
// Rust service lives behind nginx's /mp proxy, so the session cookie that
// identifies a wallet never leaves rift.rivi.us and this bundle never touches
// Redis or a price directly — the server is the only thing that may debit a
// wallet (see server/src/econ.rs).
const ROOT = '/mp/econ';

async function request(path, options = {}) {
  const response = await fetch(`${ROOT}${path}`, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json', ...(options.body ? { 'Content-Type': 'application/json' } : {}) },
    ...options,
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.error || 'The armory is temporarily unavailable.');
  return body;
}

/** `{ balance, owned }` — 0 / [] for a guest with no session. */
export const getWallet = () => request('/wallet');

/** Buy `weaponId`. Throws with a user-facing message on 401/400/402/503. */
export const purchaseWeapon = (weaponId) =>
  request('/purchase', { method: 'POST', body: JSON.stringify({ weapon: weaponId }) });
